var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.OzBaseButton,{class:[
    // Common styles
    // Remove the default focus ring since we're rounding the corners
    'focus:outline-none',
    'focus-visible:ring-[2.5px]',
    'focus-visible:ring-grape dark:focus-visible:ring-canary',

    // Centralize button content
    'flex',
    'items-center',
    'justify-center',

    // Size and spacing
    'h-11',
    'py-3',
    {
      'w-13 px-4 bg-light-ui-100 dark:bg-dark-ui-100 text-grape dark:text-canary': _vm.isActive,
      'magic-chat-icon-button w-15 px-5 hover-hover:active:bg-grape-500 hover-hover:dark:active:bg-canary-500 hover-hover:active:text-light-text-100 hover-hover:dark:active:text-dark-text-100 hover-hover:hover:bg-opacity-20':
        !_vm.isActive,
    },
    'rounded-s-[20px]',
    // Color schemes
    _vm.colorScheme === _setup.OzContainedButtonColorScheme.SecondaryClear && [
      // Base
      'bg-transparent',
      {
        'text-dark-text-200': _vm.darkMode === false,
        'text-light-text-200': _vm.darkMode === true,
        'text-dark-text-200 dark:text-light-text-200': _vm.darkMode === 'auto',
      },
      // Hovered
      'hover-hover:hover:bg-opacity-10',
      {
        'hover-hover:hover:bg-overlay-text-bg-light-mode-light-hover': _vm.darkMode === false || _vm.darkMode === 'auto',
        'hover-hover:hover:bg-overlay-text-bg-dark-mode-dark-hover': _vm.darkMode === true,
        'hover-hover:dark:hover:bg-overlay-text-bg-dark-mode-dark-hover': _vm.darkMode === 'auto',
      },
    ],

    _vm.colorScheme === _setup.OzContainedButtonColorScheme.Transparent && [
      // Disabled - Base
      'aria-disabled:bg-transparent',
      // Disabled - Hover
      'hover-hover:aria-disabled:bg-transparent',
      // Base
      {
        'bg-transparent-button-light': _vm.darkMode === false,
        'bg-transparent-button-dark': _vm.darkMode === true,
        'bg-bg-transparent-button-light dark:bg-transparent-button-dark': _vm.darkMode === 'auto',
      },
      {
        'text-dark-text-200': _vm.darkMode === false,
        'text-light-text-200': _vm.darkMode === true,
        'text-dark-text-200 dark:text-light-text-200': _vm.darkMode === 'auto',
      },
      // Hovered
      {
        'hover-hover:hover:bg-transparent-button-hover-light': _vm.darkMode === false,
        'hover-hover:hover:bg-transparent-button-hover-dark': _vm.darkMode === true,
        'hover-hover:hover:bg-transparent-button-hover-light hover-hover:dark:hover:bg-transparent-button-hover-dark':
          _vm.darkMode === 'auto',
      },
    ],
    _vm.colorScheme === _setup.OzContainedButtonColorScheme.Secondary && [
      // Base
      {
        'bg-grey-100': _vm.darkMode === false,
        'bg-grey-700': _vm.darkMode === true,
        'bg-grey-100 dark:bg-grey-700': _vm.darkMode === 'auto',
      },
      {
        'text-dark-text-200': _vm.darkMode === false,
        'text-light-text-200': _vm.darkMode === true,
        'text-dark-text-200 dark:text-light-text-200': _vm.darkMode === 'auto',
      },
      // Hovered
      {
        'hover-hover:hover:bg-grey-200': _vm.darkMode === false,
        'hover-hover:hover:bg-grey-600': _vm.darkMode === true,
        'hover-hover:hover:bg-grey-200 hover-hover:dark:hover:bg-grey-600': _vm.darkMode === 'auto',
      },
    ],
  ],attrs:{"disabled":_vm.disabled,"tabindex":_vm.isActive ? -1 : 0},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('div',{class:[
      'focus-visible:ring-[2.5px]',
      'focus-visible:ring-grape dark:focus-visible:ring-canary',
      _vm.isActive &&
        'px-3 py-2 flex items-center justify-center rounded-s-2xl rounded-e-xl hover-hover:hover:bg-grey-100 hover-hover:dark:hover:bg-grey-800',
    ],attrs:{"tabindex":_vm.isActive ? 0 : -1}},[_c(_setup.OzIcon,{attrs:{"name":"sparkles","font":"oricon","size":20}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }